<template>
    <div class="" v-if="ticketFilter != ''">
        <message-component :message="response_msg" :messageType="msg_type"></message-component>
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <!------------------------div1--------------------------------------> 
        <div v-if="($parent.showDiv == '1' && trans_id == '' && !congModule) && (ticketFilter.id != '10' || ticketFilter.id != '12' || ticketFilter.id != '13')">
            
            <div class="row align-items-center justify-content-center ">
                <div class="col-12 col-md-12 whiteBG p-4">
                    <div class="support_search  mb-3 text-center "> 
    					<h2 class="support_title mb-3" v-if="parseInt(ticketFilter.id) == 93">{{ticketFilter.title}}</h2>
                        <h2 class="support_title mb-3" v-else>{{$t('profileReq_getHelpWith')}} {{ticketFilter.title}} <span>{{$t('profileReq_Queries')}}</span></h2>
                    </div>  
                    <div class="col-12 relatedRequestOuter">
                        <div class="relatedRequest " @click.prevent="$parent.chooseRequestType(inList , ticketFilter)"  v-for="inList in ticketData[ticketFilter.id]" v-if="(parseInt(inList) == 111 && parseInt(get_user.pro_user) == 1) || (parseInt(inList) != 111 && parseInt(inList) != 112)">
                            
    						<div class="d-flex justify-content-between align-items-center">
                                {{ticketFilter.categories[inList].title}} 
                                <feather type="chevron-right"></feather> 
                            </div>
                        </div>
                    </div>
                
                    <div class="d-flex justify-content-center align-items-center"><a class="mr-3 underline d-flex justify-content-center align-items-center" href="#" @click.prevent="backTick()"><feather type="chevron-left" class="mr-1"></feather> {{$t('otpVerif_backToTicket')}}</a></div>
                </div>
            </div> 
        </div>
        <!------------------------div2-------------------------------------->
        <div class="row justify-content-center py-3 no-gutters" v-if="($parent.showDiv == '2' && trans_id == ''  && !congModule) && (ticketFilter.id != '10' || ticketFilter.id != '12' || ticketFilter.id != '13')">
            <div class="col-12 whiteBG p-4">
                <div class="row justify-content-center mobRotation">
                    
               
                    <div class="col-4">
                       <div class="col-12 leftbartopics">
                            <h2 class="mb-2">{{$t('profileReq_relatedTopics')}}</h2> 
                            <div class="height65 scrollbar">
                                <div class="relatedRequest " v-for="inList in ticketData[ticketFilter.id]" @click.prevent="$parent.chooseRequestType(inList , ticketFilter)">
                                    <div class="d-flex justify-content-between align-items-center">
                                        {{ticketFilter.categories[inList].title}}
                                        <feather type="chevron-right"></feather>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="rightside_answers">
                            <div class="border-bottom flex-wrap d-flex align-items-center justify-content-between pb-3 mb-3">
                                <h2>{{$parent.title_text}}</h2>
                                <a class="mr-3 underline" href="#" @click.prevent="backTick()">{{$t('otpVerif_backToTicket')}}</a>
                            </div>
                            <div class="mb-3">
                                <p class="mb-3" v-html='showText($parent.title_text,$parent.title)'></p>
        						<span v-if="$parent.title_text == 'Investor Password Request'">
        							<p dir='ltr' style='line-height:1.38; text-align: center;'>
        								<span style='background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;'>
        									<span style='border:none;display:inline-block;overflow:hidden;width:487px;height:286px;'>
        										<img  src="../../../../../static/fxView/images/invest_pass_image.png" width='487' height='286' class='fr-fic fr-dii' />
        									</span>
        								</span>
        							</p>
        							<p dir='ltr' style='line-height:1.38;'>
        								{{$t('profileReq_inversterPass')}}
        							</p>
        						</span>
                            </div>
                            <div class="pt-3 border-top d-flex align-items-center justify-content-end">
                                <button class="prism_btn btn_sm" v-on:click.prevent="openForm()"> {{$t('profileReq_notSatisfied')}}</button> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
        <!------------------------div3-------------------------------------->
        <div class="row no-gutters justify-content-center align-items-center  "  v-if="$parent.showDiv == '3' && trans_id == ''  && !congModule">
            <div class="whiteBG p-4 middleBox  ">
    			<div class="support_search  mb-3 text-center "> 
    				<h2 class="support_title" v-if="(parseInt(ticketFilter.id) == 10)">{{$t('profileReq_lodgeComplaint')}} </h2>
    				<h2 class="support_title" v-else-if="(parseInt(ticketFilter.id) == 12)">{{$t('profileReq_helpUsWithYour')}}  {{$parent.reason_text}}</h2>
    				<h2 class="support_title" v-else-if="(parseInt(ticketFilter.id) == 13)">{{$t('profileReq_askOtherQuestions')}} </h2>
    				<h2 class="support_title" v-else-if="parseInt(ticketFilter.id) == 16 && parseInt($parent.title) == 93">{{$t('profileReq_AddBankDetails')}} </h2>
    				<h2 class="support_title" v-else-if="parseInt(ticketFilter.id) == 16 && parseInt($parent.title) == 95">{{$t('profileReq_AddSkrillDetails')}} </h2>
    				<h2 class="support_title" v-else-if="parseInt(ticketFilter.id) == 16 && parseInt($parent.title) == 96">{{$t('profileReq_AddNetellerDetails')}} </h2>
    				<h2 class="support_title" v-else-if="parseInt(ticketFilter.id) == 16 && parseInt($parent.title) == 107">{{$t('profileReq_AddCreditCardDetails')}} </h2>
                    <h2 class="support_title" v-else-if="parseInt(ticketFilter.id) == 191"> {{$t('fxRequestIslamicAccount')}}</h2>
    				<h2 class="support_title" v-else>
    					
    					{{$t('profileReq_getHelpWith')}}  {{$parent.title_text}} {{$t('profileReq_inn')}} {{$parent.reason_text}} <span>{{$t('suppReqService_support')}}</span>
    				</h2>
    			</div>
                <!-- <span class="cross_divsec" @click="backTick()">
                    <feather type="x"></feather> 
                    {{$t('close')}}
                </span> -->

                <!----email--->
                <div v-if="parseInt(ticketFilter.id) == 1 && parseInt($parent.title) == 87">  
                    <div class="mainTitle text-center mt-4">
                        <small class="mb-4 d-block">{{$t('profileReq_emailHeading')}}</small>
                    </div>
                    <div class="CustomBlockWidth SupportBlockCenter mb-3"> 
                        <div class="form-group field-wrapper"> 
                            <input placeholder=" " class="float-field"  v-model="get_user.email" type="text"  disabled=""> 
                            <label class="float-label active">{{$t('profileReq_exsistsEmailAddress')}}</label>
                        </div>  
                        <div class="form-group field-wrapper" > 
                            <input placeholder=" " type="email" name="new_email" v-model="new_email" class="float-field form-control" v-validate="'required|email'" :class="{ 'is-invalid': submitted && errors.has('new_email') }" ref="new_emailInput" >
                            <label for="username" class="float-label">{{$t('profileReq_newEmail')}}</label> 
                            <p class="error" v-for="error in errors.collect('new_email')">
    							<span v-if="error == 'The new_email field must be a valid email.'">{{$t('profileReq_EmailfieldValid')}}</span>
    							<span v-if="error == 'The new_email field is required.'">{{$t('profileReq_EmailfieldReq')}}</span>
    						</p> 
                        </div>   

                        <div class="text-center">
                            <!-- <a class="mr-3 underline" href="#" @click="backTick()">Back To Tickets</a> -->
                            <button class="prism_btn btn_sm" v-on:click.prevent="submitNow()">{{$t('profileReq_changeEmailAddress')}} </button> 
                        </div>
                    </div>  
                </div> 
                <!----mobile--->
                <div v-else-if="parseInt(ticketFilter.id) == 1 && parseInt($parent.title) == 88">  
                    <div class="mainTitle text-center mt-4">
                       
                        <small class="mb-4 d-block">{{$t('profileReq_mobileHeading')}}</small>
                    </div>
                    <div class="CustomBlockWidth SupportBlockCenter  mb-3 changeno_sec"> 
                        <div class="form-group field-wrapper"> 
                            <input placeholder=" " class="float-field"  v-model="get_user.mobile_no" type="text"  disabled=""> 
                            <label class="float-label active">{{$t('profileReq_existingMobileNumber')}}</label>
                        </div> 

                        <div class="form-group field-wrapper phone-wrapper"> 
    						<vue-phone-number-input
                                v-model="new_mobile"
                                :no-example="true"
                                :default-country-code="userCountry"
                                v-validate="{ required: true, min:5, max:15 }"
                                ref="new_mobileInput"
                                class="float-field form-control"
                                :class="{ 'is-invalid': submitted && errors.has('new_mobile') }"
                                name="new_mobile"
                                @update="updatedText"/>  
                            <p class="error mt-2" v-if="submitted" v-for="error in errors.collect('new_mobile')">{{$t('profileReq_InvalidNumber')}}</p>  
                        </div>  
<!--                     
                        <div class="form-group field-wrapper"> 
    						<vue-phone-number-input v-model="new_mobile"  :no-example="true" :default-country-code="userCountry" v-validate="{ required: true,max:15, min: 5 }" ref="new_mobileInput" :class="{ 'is-invalid': submitted && errors.has('new_mobile') }" name="new_mobile" @update="updatedText"/>
                           
                            <p class="error" v-if="!(numberValid)">{{$t('profileReq_InvalidNumber')}}</p> 
                        </div>    -->
                        <div class="text-center">
                            <!-- <a class="mr-3 underline" href="#" @click.prevent="backTick()">Back To Tickets</a> -->
                            <button class="prism_btn btn_sm" v-on:click.prevent="submitNow()">{{$t('profileReq_changeMobileNumber')}}</button> 
                        </div>
                    </div> 
                </div>
                <!----change address--->
                <div v-else-if="parseInt(ticketFilter.id) == 1 && parseInt($parent.title) == 90"> 
                        <form action="" method="post" enctype="multipart/form-data" id="addressForm" v-on:submit.prevent="submitNow()"> 
                             
                            <div class="CustomBlockWidth SupportBlockCenter mb-3">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group field-wrapper" > 
                                            <input placeholder=" " class="float-field form-control" name="address1"  type="text" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('address1') }" ref="address1Input" >
                                            <label for="username" class="float-label">{{$t('prof_addressLine1')}} </label> 
                                            <p class="error" v-for="error in errors.collect('address1')">{{ error }}</p>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group field-wrapper" > 
                                            <input placeholder=" " class="float-field form-control" name="address2"  type="text" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('address2') }" ref="address2Input" >
                                            <label for="username" class="float-label"> {{$t('prof_addressLine2')}}</label> 
                                            <p class="error" v-for="error in errors.collect('address2')">{{ error }}</p>
                                        </div> 
                                    </div>
                                </div>  
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group field-wrapper" > 
                                            <input placeholder=" " class="float-field form-control" name="post_code"  type="text" v-validate="{ required: true, min: 3, max: 12, numeric: true }" :class="{ 'is-invalid': submitted && errors.has('post_code') }" ref="post_codeInput" >
                                            <label for="username" class="float-label"> {{$t('prof_postCode')}}</label> 
                                            <p class="error" v-for="error in errors.collect('post_code')">{{$t('profileReq_postCodeRequired')}}</p> 
                                        </div> 
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group field-wrapper" > 
    										<select name="residence_country" v-validate="'required'" v-model="residence_country" :class="(residence_country != ''?'active' :'') || ({ 'is-invalid': submitted && errors.has('residence_country') })" ref="residence_countryInput" class="float-field form-control">
    											<option v-for="list in countriesList" :value="list.iso2">{{list.name}}</option>
    										</select>
                                            <label for="username" class="float-label"> {{$t('prof_resCountry')}}</label> 
                                            <p class="error" v-for="error in errors.collect('residence_country')">{{$t('profileReq_residenceCountryRequired')}}</p>
                                        </div>
                                    </div>
                                </div> 
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group field-wrapper" > 
                                            <input placeholder=" " class="float-field form-control" name="city"  type="text" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('city') }" ref="cityInput" >
                                            <label for="username" class="float-label"> {{$t('prof_city')}}</label> 
                                            <p class="error" v-for="error in errors.collect('city')">{{ error }}</p> 
                                        </div> 
                                    </div>
                                </div> 
                                <div class="row">
                                    <div class="col-12">
                                        <div class="field-wrapper">  
                                            <div class="supportingdocument w-100">
    											<p class="btn" @click.prevent="$refs.address.click()" :class="{ 'is_invalid': submitted && errors.has('document[]') }"><feather type="upload" class="mr-2"></feather>{{$t('profileReq_uploadRecentAddressProof')}} </p>
    											<input type="file"  name="document[]" value="Upload Document" ref="address" v-on:change="onFileChange('address', $event.target.files)" v-validate="'required'" class="float-field form-control" id="address" :class="{ 'is-invalid': submitted && errors.has('document[]') }" />
    											<p class="error" v-for="error in errors.collect('document[]')">{{$t('profileReq_docReq')}}</p> 
                                            
                                            </div>
                                            <!-- this div comes when user slect document -->
                                            <div class="linerUpload d-flex align-items-center mb-3" v-if="document_proof_array.address != ''">
                                              <span class="nameIco"><feather class="mr-2" type="file"></feather> {{document_proof_array.address}}  </span>
                                              <a href="#" class="closeBtn" @click.prevent="clearDoc('address')"><feather type="x"></feather></a>
                                            </div>
                                        </div>   
                                    </div>
                                </div>
                                <div class="text-center">
                                    <!-- <a class="mr-3 underline" href="#" @click.prevent="backTick()">Back To Tickets</a> -->
                                    <button class="prism_btn btn_sm"> {{$t('profileReq_changeAddress')}}</button> 
                                </div>
                            </div> 
                        </form>
                     </div> 
                
                <!----skrill and netteller--->
                <div class="row justify-content-center" v-else-if="parseInt(ticketFilter.id) == 16">
                    <div class="CustomBlockWidth  mb-3">
    					<form action="" method="post" enctype="multipart/form-data" id="bankForm" v-on:submit.prevent="submitNow()" v-if="parseInt($parent.title) == 93 || parseInt($parent.method_id) == 1">
                            
    						<div class="CustomBlockWidth SupportBlockCenter mb-3"> 
    							<div class="row">
    								<div class="col-12">
    									<div class="form-group field-wrapper" > 
    										<input placeholder=" " class="float-field form-control" name="bank_name"  type="text" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('bank_name') }" ref="bank_nameInput"  >
    										<label for="username" class="float-label">{{$t('profileReq_bankName')}}</label> 
    										<p class="error" v-for="error in errors.collect('bank_name')">{{$t('profileReq_bankNameRequired')}}</p> 
    									</div> 
    									 
    								</div>
    								<div class="col-6">
    									<div class="form-group field-wrapper" > 
    										<input placeholder=" " class="float-field form-control" name="holder_name"  type="text" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('holder_name') }" ref="holder_nameInput" >
    										<label for="username" class="float-label">{{$t('profileReq_AccountName')}}</label> 
    										<p class="error" v-for="error in errors.collect('holder_name')">{{$t('profileReq_accountHolderRequired')}}</p> 
    									</div>
    								</div>
    								<div class="col-6"> 
    									<div class="form-group field-wrapper" > 
    										<input placeholder=" " class="float-field form-control" name="account_no"   type="text" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('account_no') }" ref="account_noInput"  >
    										<label for="username" class="float-label">{{$t('profileReq_AccNumber')}}</label> 
    										<p class="error" v-for="error in errors.collect('account_no')">{{$t('profileReq_accountNumberRequired')}}</p> 
    									</div> 
    								</div>
    								<div class="col-6"> 
    									<div class="form-group field-wrapper" > 
    										<select name="country" v-validate="'required'" v-model="countrybank" :class="(countrybank != ''?'active' :'') || ({ 'is-invalid': submitted && errors.has('country') })" ref="countryInput" class="float-field form-control">
    											<option v-for="list in countriesList" :value="list.iso2">{{list.name}}</option>
    										</select>
    										<label for="username" class="float-label">{{$t('profileReq_country')}}</label> 
    										<p class="error" v-for="error in errors.collect('country')">{{$t('profileReq_countryFieldRequired')}}</p> 
    									</div> 
    								</div>
    								<div class="col-6"> 
    									<div class="form-group field-wrapper mb-0"> 
    										<input placeholder=" " class="float-field form-control" name="micr"  type="text"  v-validate="(iban_not_issue)?'': 'required'" :class="{ 'is-invalid': submitted && errors.has('micr') }" ref="micrInput" :disabled="(iban_not_issue)? true : false">
    										<label for="username" class="float-label">{{$t('profileReq_IBAN')}}</label>
                                            <p class="error mb-2" v-if="submitted" v-for="error in errors.collect('micr')">{{$t('profileReq_ibanRequired')}}</p>   
    									</div>  
                                        <label class="fancy_radiochk_btn ibancheckbox stitle mb-3 none-before align-items-center d-flex">
                                            <small>{{$t('profileReq_MyBankNotIBAN')}}</small>
                                            <input type="checkbox" v-model="iban_not_issue"  @change="$refs.micrInput.value = ''">
                                            <span class="checkmark"></span>
                                        </label>
                                        
    								</div>
    								<div class="col-6"> 
    									<div class="form-group field-wrapper" > 
    										<input placeholder=" " class="float-field form-control" name="sort_code"  type="text" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('sort_code') }" ref="sort_codeInput" >
    										<label for="username" class="float-label">{{$t('profileReq_SwiftCode')}}</label>
    										<p class="error" v-for="error in errors.collect('sort_code')">{{$t('profileReq_swiftCodeRequired')}}</p>  
    									</div> 
    								</div>
    								<div class="col-12"> 
                                        
    									<div class="form-group field-wrapper" > 
    										<input placeholder=" " class="float-field form-control" name="bank_address"  type="text" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('bank_address') }" ref="bank_addressInput" >
    										<label for="username" class="float-label">{{$t('profileReq_bankAdd')}}</label> 
    										<p class="error" v-for="error in errors.collect('bank_address')">{{$t('profileReq_bankAddressRequired')}}</p> 
    									</div>  
    								</div>
    								<div class="col-12">
    									<div class="field-wrapper ">  
    										<div class="supportingdocument w-100" >
    											<p class="btn mb-0" @click.prevent="$refs.bank.click()" :class="{ 'is_invalid': submitted && errors.has('document[]') }"><feather type="upload" class="mr-2"></feather>{{$t('profileReq_UpBankStatement')}} </p>
    											<input type="file"  name="document[]" value="Upload Document" ref="bank" v-on:change="onFileChange('bank', $event.target.files)" v-validate="'required'" class="float-field form-control"  id="bank" :class="{ 'is-invalid': submitted && errors.has('document[]') }" />
    											<p class="error mb-2" v-for="error in errors.collect('document[]')">{{$t('profileReq_docReq')}}</p> 

                                                
    										</div>
                                            <div class="supportingdocument " >
                                                <p>{{$t('profileReq_fileallow')}}</p>
                                            </div>
    										<!-- this div comes when user slect document -->
    										<div class="linerUpload d-flex align-items-center mb-3" v-if="document_proof_array.bank != ''">
    										  <span class="nameIco"><feather class="mr-2" type="file"></feather> {{document_proof_array.bank}}  </span>
    										  <a href="#" class="closeBtn" @click.prevent="clearDoc('bank')"><feather type="x"></feather></a>
    										</div>
    										
    									</div> 
    								</div>
    							</div>  
    							<div class="text-center">
    								<!-- <a class="mr-3 underline" href="#" @click.prevent="backTick()">Back To Tickets</a> -->
    								<button class="prism_btn btn_sm"> {{$t('profileReq_addNewBank')}}</button> 
    							</div>
    						</div> 
    					</form>
    					<form action="" method="post" enctype="multipart/form-data" id="formRequest" v-on:submit.prevent="submitNow()" v-if="parseInt($parent.title) == 107">
    						<div class="cardcontainer">
    							<!-- Small Side Card detail-->
    							<div class="subContainer">
    								<div class="cardHolderName">{{get_user.username}}</div>
    								<!-- svg Logo-->
    								<div class="visaCont" v-if="creditCardType != ''">
    									<img :src="'../../../../../static/fxView/images/'+creditCardType" alt="card">
    								</div>
    								<div class="cardNum">
    									<ul>
    										<li>
    											<input type="text" placeholder="----" class="cardinput form-control" v-model="first_digit_card" name="first_digit_card" maxlength="4"  v-validate="{ required: true, max: 4,numeric : true }" :class="{ 'is-invalid': submitted && errors.has('first_digit_card') }" ref="first_digit_cardInput" v-on:keyup="keymonitor">
    											
    										</li>
    										<li>****</li>
    										<li>****</li>
    										<li>
    											<input type="text" placeholder="----" class="cardinput form-control" v-model="last_digit_card" name="last_digit_card" maxlength="4"  v-validate="{ required: true, max: 4,numeric : true }" :class="{ 'is-invalid': submitted && errors.has('last_digit_card') }" ref="last_digit_cardInput">
    										</li>
    									</ul>
    									<p class="error" v-if="!errors.first('first_digit_card') && msz != ''">{{ msz }}</p>
    									<p class="error" v-for="error in errors.collect('last_digit_card')">{{$t('profileReq_last4Digit')}}</p> 
    									<p class="error" v-for="error in errors.collect('first_digit_card')">{{$t('profileReq_first4Digit')}}</p>
    								</div>
    								<div class="date">
    									<p class="datepara">
    										<select id="expiry-date" class="selectExpiryDate form-control" name="month"  v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('month') }" ref="monthInput">
    											<option value="">--</option>
    											<option value="01">01</option>
    											<option value="02">02</option>
    											<option value="03">03</option>
    											<option value="04">04</option>
    											<option value="05">05</option>
    											<option value="06">06</option>
    											<option value="07">07</option>
    											<option value="08">08</option>
    											<option value="09">09</option>
    											<option value="10">10</option>
    											<option value="11">11</option>
    											<option value="12">12</option>
    										</select>
    										<span>/</span>
    										<select id="expiry-date" class="selectExpiryDate form-control" name="year"  v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('year') }" ref="yearInput">
    											<option value="">----</option>
    											
                                                <option value="2020">2020</option>
    											<option value="2021">2021</option>
    											<option value="2022">2022</option>
    											<option value="2023">2023</option>
    											<option value="2024">2024</option>
    											<option value="2025">2025</option>
    											<option value="2026">2026</option>
    											<option value="2027">2027</option>
    											<option value="2028">2028</option>
    											<option value="2029">2029</option>
    											<option value="2030">2030</option>
    										</select>
    									</p>
    								</div>
    								<div class="ccv">
    									<p>***</p>
    								</div>
    							</div>
    						</div>
    						<div class="backlayer"></div>	
    						<div class="field-wrapper">  
                                <div class="supportingdocument w-100">
    								<p class="mb-2">{{$t('profileReq_frontBack')}}</p>
    								<p class="mb-2">{{$t('profileReq_frontPhotoCredit')}}</p>
    								<p class="btn" @click.prevent="$refs.ccFront.click()" :class="{ 'is_invalid': submitted && errors.has('document[]') }"><feather type="upload" class="mr-2"></feather>{{$t('profileReq_uploadSupportingDocument')}} </p>
    								<input type="file"  name="document[]" value="Upload Document" ref="ccFront" v-on:change="onFileChange('ccFront', $event.target.files)" v-validate="'required'" class="float-field form-control" id="ccFront" :class="{ 'is-invalid': submitted && errors.has('document[]') }" />
                             
                                </div>
                                <div class="linerUpload d-flex align-items-center mb-3" v-if="document_proof_array.ccFront != ''">
                                  <span class="nameIco"><feather class="mr-2" type="file"></feather> {{document_proof_array.ccFront}}  </span>
                                  <a href="#" class="closeBtn"  @click.prevent="clearDoc('ccFront')"><feather type="x"></feather></a>
                                </div>
                            </div> 
    						<div class="field-wrapper">  
                                <div class="supportingdocument w-100">
    								<p class="mb-2">{{$t('profileReq_backPhotoCredit')}}</p>
    								<p class="btn" @click.prevent="$refs.ccBack.click()" :class="{ 'is_invalid': submitted && errors.has('document[]') }"><feather type="upload" class="mr-2"></feather>{{$t('profileReq_uploadSupportingDocument')}} </p>
    								<input type="file"  name="document[]" value="Upload Document" ref="ccBack" v-on:change="onFileChange('ccBack', $event.target.files)" v-validate="'required'" class="float-field form-control" id="ccBack" :class="{ 'is-invalid': submitted && errors.has('document[]') }" />
                             
                                </div>
                                <div class="linerUpload d-flex align-items-center mb-3" v-if="document_proof_array.ccBack != ''">
                                  <span class="nameIco"><feather class="mr-2" type="file"></feather> {{document_proof_array.ccBack}}  </span>
                                  <a href="#" class="closeBtn"  @click.prevent="clearDoc('ccBack')"><feather type="x"></feather></a>
                                </div>
                            </div> 
                            <div class="text-center">
                                <button class="prism_btn btn_sm"> {{$t('profileReq_submit')}}</button> 
                            </div>
                        </form>

    					<form action="" method="post" enctype="multipart/form-data" id="formRequest" v-on:submit.prevent="submitNow()" v-if="parseInt($parent.title) == 95 || parseInt($parent.title) == 96 || parseInt($parent.title) == 195">
                            <div class="form-group field-wrapper">   
                                <input type="text" name="online_payment_id" class="float-field form-control" v-validate="{ required: true}" :class="{ 'is-invalid': submitted && errors.has('online_payment_id') }" ref="online_payment_idInput">
                                <label class="float-label" v-html="($parent.method_id != '')? ((parseInt($parent.method_id) == 2)? 'Please enter email address used in your Skrill wallet' : 'Please enter email address used in your Neteller wallet') : 'Please enter email address used in your '+$parent.title_text+' wallet'"></label>
                                <p class="error" v-for="error in errors.collect('online_payment_id')">{{$t('profileReq_paymentRequiredNumeric')}}</p> 
                            </div> 
                            <div class="field-wrapper"> 
    							{{$t('profileReq_netSkrill1')}} {{$parent.title_text}} {{$t('profileReq_netSkrill2')}} {{$parent.title_text}} {{$t('profileReq_netSkrill3')}}
                                <div class="supportingdocument w-100">
    								<p class="btn" @click.prevent="$refs.skillNet.click()" :class="{ 'is_invalid': submitted && errors.has('document[]') }"><feather type="upload" class="mr-2"></feather>{{$t('profileReq_uploadSupportingDocument')}} </p>
    								<input type="file"  name="document[]" value="Upload Document" ref="skillNet" id="skillNet" v-on:change="onFileChange('skillNet', $event.target.files)" v-validate="'required'" class="float-field form-control" :class="{ 'is-invalid': submitted && errors.has('document[]') }" />
    								<p class="error" v-for="error in errors.collect('document[]')">{{$t('profileReq_docReq')}}</p> 
                             
                                </div>
                                <!-- this div comes when user slect document -->
                                <div class="linerUpload d-flex align-items-center mb-3" v-if="document_proof_array.skillNet != ''">
                                  <span class="nameIco"><feather class="mr-2" type="file"></feather> {{document_proof_array.skillNet}}  </span>
                                  <a href="#" class="closeBtn"  @click.prevent="clearDoc('skillNet')"><feather type="x"></feather></a>
                                </div>
                            </div> 
                            <div class="text-center">
                                <!-- <a class="mr-3 underline" href="#" @click="backTick()">Back To Tickets</a> -->
                                <button class="prism_btn btn_sm"> {{$t('profileReq_submit')}}</button> 
                            </div>
                        </form>
                    </div>
                </div>
                
    			<!----complaints--->
                <div class="row justify-content-center" v-else-if="parseInt($parent.title) == 10">
                    <div class="CustomBlockWidth  mb-3">
                        <form action="" method="post" enctype="multipart/form-data" id="formRequest" v-on:submit.prevent="submitNow()"> 
    						<h4 class="mb-3">{{$t('profileReq_userDetails')}}</h4>
    						<div class="form-group field-wrapper mb-0">
    							<input placeholder=" " type="hidden" name="legal_entity" class="float-field form-control" >
                                <!--<label class="float-label">{{$t('legalEntityName')}}</label>-->
                            </div>
    						<div class="form-group field-wrapper">
    							<account-id></account-id>
    						</div> 
    						<h4 class="mb-3">{{$t('profileReq_ComplaintDetails')}}</h4>
                            <div class="row">
                                <div class="col-12 col-md-12">
                                    <div class="form-group field-wrapper">  
                                        <input placeholder=" " type="text" name="employee" class="float-field form-control" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('employee') }" ref="employeeInput">
                                        <label class="float-label"> {{$t('profileReq_employeeWhoOffered')}}</label>
                                        <p class="error" v-for="error in errors.collect('employee')">{{ error }}</p>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12">
                                    <div class="form-group field-wrapper">  
                                        <label>{{$t('profileReq_timeDisputed')}}</label>
    									<datepicker  v-model="dispute_time" placeholder=" "  class="w-100"   name="dispute_time" v-validate="'required'"  :class="{ 'is-invalid': submitted && errors.has('dispute_time') }" ref="dispute_timeInput"  type="date" :lang="lang" format="YYYY-MM-DD 00:00:00"   :not-after="disabledDates"></datepicker> 
                                        <p class="error" v-for="error in errors.collect('dispute_time')">{{$t('profileReq_TheDisputeTime')}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-12">
                                    <div class="form-group field-wrapper">  
                                        <input placeholder=" " type="text" name="order" class="float-field form-control" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('order') }" ref="orderInput">
                                        <label class="float-label"> {{$t('profileReq_ticNoContested')}}</label>
                                        <p class="error" v-for="error in errors.collect('order')">{{ error }}</p>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12">
                                    <div class="form-group field-wrapper">  
                                        <input placeholder=" " type="text" name="amount" class="float-field form-control" v-validate="{ required: true,decimal:10}" :class="{ 'is-invalid': submitted && errors.has('amount') }" ref="amountInput">
                                        <label class="float-label"> {{$t('profileReq_DisputedAmount')}}</label>
                                        <p class="error" v-for="error in errors.collect('amount')">{{ error }}</p>
                                    </div>
                                </div>
                            </div>
                             
    						<div class="form-group field-wrapper"> 
                                <label class="text-left fancy_radiochk_btn">
                                    <input type="checkbox" class="form-control" v-model="authority" name="authority" ><span class="checkmark" ></span>
                                    {{$t('profileReq_reportComplaint')}}
                                </label> 
                            </div> 
    						<div class="form-group field-wrapper" v-if="authority">  
                                <input placeholder=" " type="text" name="authority_name" class="float-field form-control" v-validate="(authority)?'required' : ''" :class="{ 'is-invalid': submitted && errors.has('authority_name') }" ref="authority_nameInput">
                                <label class="float-label">{{$t('profileReq_stateNameAuth')}}</label>
                                <p class="error" v-for="error in errors.collect('authority_name')">{{$t('profileReq_TheAuthorityName')}}</p>
                            </div>
                            <div class="form-group field-wrapper">   
                                <textarea class="float-field form-control" placeholder=" "  name="text" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('text') }" ref="textInput">
                                </textarea>
    							<label class="float-label"> {{$t('profileReq_DetailedDescript')}} </label>
    							<p class="error" v-for="error in errors.collect('text')">{{ error }}</p>
                            </div>  
    						<div class="field-wrapper">  
    							<p class="mb-3">{{$t('profileReq_attachTogetherForm')}}</p>

                                <div class="supportingdocument w-100">
                                  <p class="btn" @click.prevent="$refs.complaint.click()"><feather type="upload" class="mr-2"></feather>{{$t('profileReq_uploadSupportingDocument')}} </p>
                                  <input type="file"  name="document[]" value="Upload Document" ref="complaint" id="complaint" v-on:change="onFileChange('complaint', $event.target.files)"/>
                                </div>
                                <!-- this div comes when user slect document -->
                                <div class="linerUpload d-flex align-items-center mb-3" v-if="document_proof_array.complaint != ''">
                                  <span class="nameIco"><feather class="mr-2" type="file"></feather> {{document_proof_array.complaint}}  </span>
                                  <a href="#" class="closeBtn"  @click.prevent="clearDoc('complaint')"><feather type="x"></feather></a>
                                </div>
                            </div>
                            <div class="text-center">
                                <!-- <a class="mr-3 underline" href="#" @click="backTick()">Back To Tickets</a>  -->
                                <button class="prism_btn btn_sm">{{$t('profileReq_submit')}}</button> 
                            </div>
                        </form>     
                    </div>
                </div>

                <div class="row justify-content-center" v-else-if="parseInt($parent.reason) == 191">
                    <div class="CustomBlockWidth  mb-3">
                        <form action="" method="post" enctype="multipart/form-data" id="formRequest" v-on:submit.prevent="submitNow()"> 
                            <!-- <h4 class="mb-3">{{$t('profileReq_userDetails')}}</h4> -->
                            <small>{{ $t('fxNoteInOrder') }}</small>

                            <div class="field-wrapper mt-3">
                                <label class="text-left fancy_radiochk_btn">
                                    {{ $t('fxIDoNotHave') }}
                                    <input type="checkbox"  class="form-control" v-model="agree" v-validate="'required'" name="agree"  :class="{ 'is-invalid': submitted && errors.has('agree') }" ref="check4Input"><span class="checkmark"></span>
                                </label>
                                <p class="error" v-for="error in errors.collect('agree')">{{$t('step4_termsAgreeRqd')}}</p>
                            </div>
                            <div class="text-center">
                                <!-- <a class="mr-3 underline" href="#" @click="backTick()">Back To Tickets</a>  -->
                                <button class="prism_btn btn_sm">{{$t('profileReq_submit')}}</button> 
                            </div>
                        </form>     
                    </div>
                </div>
    			
    			<!----rest all--->
                <div class="row justify-content-center" v-else>
                    <div class="CustomBlockWidth col-md-12">
                        <form action="" method="post" enctype="multipart/form-data" id="formRequest" v-on:submit.prevent="submitNow()"> 
                            <div class="form-group field-wrapper">  
                                <input placeholder=" " type="text" name="subject" class="float-field form-control" v-validate="'required|min:3'" :class="{ 'is-invalid': submitted && errors.has('subject') }" ref="subjectInput">
                                <label class="float-label"> {{$t('profileReq_Subject')}}</label>
                                <p class="error" v-for="error in errors.collect('subject')">{{ error }}</p>
                            </div>
                            <div class="form-group field-wrapper">   
                                <textarea class="float-field form-control" :placeholder="$t('profileReq_yourMsz')"  name="text" v-validate="'required|min:3'" :class="{ 'is-invalid': submitted && errors.has('text') }" ref="textInput">
                                </textarea>
                                <p class="error" v-for="error in errors.collect('text')">{{ error }}</p>
                            </div> 
                            <div class="field-wrapper">
    					
                                <div class="supportingdocument w-100">
                                  <p class="btn" @click.prevent="$refs.rest.click()"><feather type="upload" class="mr-2"></feather>{{$t('profileReq_uploadSupportingDocument')}} </p>
                                  <input type="file"  name="document[]" value="Upload Document" ref="rest" id="rest" v-on:change="onFileChange('rest', $event.target.files)"/>	
                                </div>
                                <!-- this div comes when user slect document -->
                                <div class="linerUpload d-flex align-items-center mb-3" v-if="document_proof_array.rest != ''">
                                  <span class="nameIco"><feather class="mr-2" type="file"></feather> {{document_proof_array.rest}}  </span>
                                  <a href="#" class="closeBtn" @click.prevent="clearDoc('rest')"><feather type="x"></feather></a>
                                </div>
                            </div>  
                            
                            <div class="text-center">
                                <!-- <a class="mr-3 underline" href="#" @click="backTick()">Back To Tickets</a>  -->
                                <button class="prism_btn btn_sm">{{$t('profileReq_submit')}}</button> 
                            </div>
                        </form>     
                    </div>
                </div> 
            </div>
        </div> 
        <!------------------------div4-------------------------------------->
       
		<div class="" v-if="(trans_id != '' && !congModule && !authComponent)"> 
            <app-OptVerfication :transaction_id="trans_id" :module="$parent.reason" :title_parent="$parent.title" :data="''" :ticketRequestFrom="ticketRequest" :accountId="accountIdFrom"></app-OptVerfication>
			<!--<p v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 0" @click="authComponent = true">Enable 2FA</p>-->
        </div>
		
		<!--<div v-if="(trans_id != '' && !congModule  && authComponent)">
			<app-twofa  :call_from="request_page"></app-twofa>
			<p @click="authComponent = false">I'll do later</p>
		</div>-->
        <!------------------------div5-------------------------------------->
        <div class="mt-2 " v-if="congModule"> 
            <div class="row no-gutters justify-content-center ">
                <div class=" whiteBG p-4 middleBox ">
                    <div class="congratulations">
						<div class="support_search  mb-3 text-center " v-if="(parseInt(ticketFilter.id) == 10 ||  parseInt(ticketFilter.id) == 12 ||  parseInt(ticketFilter.id) == 13)"> 
							<h3 class="support_title">{{$t('profileReq_getHelpWith')}}  {{$parent.reason_text}} <span>{{$t('leftnav_support')}}</span></h3>
						</div>
                        <div class="support_search  mb-3 text-center " v-else-if="parseInt(ticketFilter.id) == 191"> {{$t('fxRequestIslamicAccount')}}</div>
						<div class="support_search mb-3 text-center " v-else> 
							<h3 class="support_title ">{{$t('profileReq_getHelpWith')}}  {{$parent.title_text}} {{$t('profileReq_inn')}} {{$parent.reason_text}} <span>{{$t('leftnav_support')}}</span></h3>
						</div>
                        <div class="logo_congrats">
                            <img src="../../../../../static/fxView/images/congrats.png" alt="Icon">
                        </div>
                        <div class="subtitle">
                            <h3>{{$t('sub_congo')}} <span class="green">{{get_user.username}}</span></h3> 
                            
							<p v-if="parseInt(ticketFilter.id) == 1 && parseInt($parent.title) == 10">{{$t('profileReq_ticketHasbeenComplaint')}}</p>
							<p v-else>{{$t('profileReq_ticketHasbeenCreated')}}</p>
                        </div>
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                        <router-link :to="{ name: 'fxView.support', params: {tabName:'openRequest'}}" class="prism_btn btn_sm">{{$t('profileReq_proMsz19')}} </router-link>
                    </div>
                </div>  
            </div>
        </div> 
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'  
    import optVerfication from './otp_verification'
	import Datepicker from 'vue2-datepicker'
	import twoFa from '../../users/2FA'
	import moment from 'moment'
    const support_text = require('../../../../../static/fxView/js/support.json')
    export default {
        mixins:[fxViewMixins],
        data(){
            return {
				authComponent : false,
				request_page : 'tickets',
				//-----select account----
				selectAccount : false,
                account_id : '',
				act_account_id : '',
				demo_live : '',
				platform :'',
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                loaderFuncRun : '1',
                //==========================================
				authority : false,
				countrybank : '',
                //mobile
                new_mobile : '',
                agree:false,

                //email
                new_email : '',
                submitted : false,
                informationRequired: 1,
                //credit card 
				first_digit_card : '',
				last_digit_card : '',
				creditCardType : '',
				//complaints
				lang: {
					formatLocale: {
						firstDayOfWeek: 1,
					},
					monthBeforeYear: false,
				},
				dispute_time : '',
                congModule : false,
                trans_id : '',
                comment : '',
				
                iban_not_issue : false,

                entension_allowed : ['image/png','application/pdf','text/csv','application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','text/plain'],
                 document_proof_array : {
                    'bank' : '',
                    'address' : '',
                    'skillNet' : '',
                    'rest' : '',
					'complaint' : '',
					'ccBack' : '',
					'ccFront' : ''
                },
				msz : '',
				numberWithCountry : '',
				numberValid : true,
				userCountry : 'IN',
				disabledDates :new Date(),
				residence_country : '',
				
				disabledBefore: new Date(2019, 10, 2),
				disabledAfter: new Date(2020, 6, 31)

            }
        },
        props:['ticketFilter','ticketRequest','accountIdFrom'],
        components: {
            appOptVerfication : optVerfication,
			datepicker : Datepicker,
			appTwofa: twoFa
        },
        methods:{
			customFormatter(date) {
                return moment(date).format('DD-MM-YYYY  hh:mm:ss');
            },
			updatedText(e){
                this.numberWithCountry = e.formattedNumber
                this.numberValid = e.isValid
            },
			keymonitor(){
				if(this.first_digit_card != ''){
					if(this.first_digit_card.charAt(0) == '4'){
						this.msz = ''
						this.creditCardType = 'visa.svg'
					}else if(this.first_digit_card.charAt(0) == '5'){
						this.msz = ''
						this.creditCardType = 'mastercard.svg'
					}else if(this.first_digit_card.charAt(0) == '6'){
						this.msz = ''
						this.creditCardType = 'american_express.svg'
					}else{
						this.msz = this.$t('profileReq_entervalidcard')
					}
				}else{this.creditCardType = ''}
			},
			clearDoc(getdocType){
				document.getElementById(getdocType).value = '' 
				this.document_proof_array[getdocType] = ''
			},
            onFileChange(getdocType , file) {
                this.document_proof_array[getdocType] = file[0].name
            },
            showText(title,key){
                 const text = title.split(" ").join('')
                // return this.$t(text)
                return support_text[key] || '-';
            },
            backTick(){
                this.$parent.loadServiceRequest = ''
                this.$parent.serviceRequest = true
				this.$parent.reason = '',
				this.$parent.reason_text = '',
				this.$parent.title = '0',
				this.$parent.title_text = ''
				this.$parent.inList_custom_id = ''
				this.$parent.info_req = ''
            },
            openForm(){ 
                this.$parent.showDiv = '3'
            },
            submitNow(){
                const _that = this
                _that.submitted = true;
                if(parseInt(_that.ticketFilter.id) == 1 && parseInt(_that.$parent.title) == 87){
                    let comment = _that.$t('profileReq_changeEmail') + this.get_user.email + _that.$t('profileReq_NEWEmail') +  this.new_email
                    _that.$validator.validate().then(valid => {
                        if (valid){
                            let input_json={
                                'globalParams' :{
                                    'email' : _that.new_email,
                                    'reason' : _that.$parent.reason, 
                                    'reason_text' : _that.$parent.reason_text,
                                    'title'  : _that.$parent.title,
                                    'title_text'  : _that.$parent.title_text,
                                    'text' : comment
                                },
                                'localParams' :{ "parameter" : _that }
                            }
                            _that._runTicketRequestOtp(input_json)
                        }
                    })
                }else if(parseInt(_that.$parent.reason) == 191){
                    let formRequest = document.getElementById('formRequest');
                    let form_name = new FormData(formRequest);

                    let subject = "Please enable islamic trading account type"
                    let reason_text = "Enable Islamic account"
                    if(parseInt(this.get_user.pro_user)==1){
                        subject = "Please disable islamic trading account type"
                        reason_text = "Disable Islamic account"
                    }

                    form_name.append("reason", _that.$parent.reason);
                    form_name.append("reason_text", reason_text);
                    form_name.append("title", _that.$parent.title);
                    form_name.append("title_text", _that.$parent.title_text);
                    form_name.append("subject", subject);
                    form_name.append("text", subject);
                    form_name.append("document", []);
                    
                    _that.$validator.validate().then(valid => {
                        if (valid){
                            let input_json={
                                'globalParams' :{
                                    'form' : form_name
                                },
                                'localParams' :{ "parameter" : _that , 'module' : 'ticket-reply'  }
                            }
                            _that._runTicketRequestOtp(input_json)
                        }
                    })
                }

                else if(parseInt(_that.ticketFilter.id) == 1 && parseInt(_that.$parent.title) == 10){
                    let formRequest = document.getElementById('formRequest');
                    let form_name = new FormData(formRequest);
                       // pehle complaint yeh tha , ab complint ka ticketfilter.id = 1 reason, title 10 
                        if(!(_that.authority)){
                            form_name.append("authority_name", '');
                        }
                        form_name.append("authority", _that.authority);
                        form_name.append("account_id", _that.account_id);
                        form_name.append("act_account_id", _that.act_account_id);
                    
                    
                    form_name.append("reason", _that.$parent.reason);
                    form_name.append("reason_text", _that.$parent.title_text);
                    form_name.append("title", _that.$parent.title);
                    form_name.append("title_text", _that.$parent.title_text); 
                    
                    _that.$validator.validate().then(valid => {
                        if (valid){
                            let input_json={
                                'globalParams' :{
                                    'form' : form_name
                                },
                                'localParams' :{ "parameter" : _that , 'module' : 'ticket-reply'  }
                            }
                            _that._runTicketRequestOtp(input_json)
                        }
                    })
                }

                else if(parseInt(_that.ticketFilter.id) == 1 && parseInt(_that.$parent.title) == 88){
                    let comment = this.$t('profileReq_changeMobile') + this.get_user.mobile_no + this.$t('profileReq_newNumber') +  this.new_mobile
                    _that.$validator.validate().then(valid => {
                        if (valid){
                            let input_json={
                                'globalParams' :{
                                    'mobile' : _that.numberWithCountry,
                                    'reason' : _that.$parent.reason, 
                                    'reason_text' : _that.$parent.reason_text,
                                    'title'  : _that.$parent.title,
                                    'title_text'  : _that.$parent.title_text,
                                    'text' : comment
                                },
                                'localParams' :{ "parameter" : _that }
                            }
                            _that._runTicketRequestOtp(input_json)
                        }
                    })
                }else if(parseInt(_that.ticketFilter.id) == 16 && parseInt(_that.$parent.title) == 93){
                    let bankForm = document.getElementById('bankForm');
                    let comment = _that.$t('profileReq_changebankinfo')+ bankForm.elements[0].value + _that.$t('profileReq_holdername') +  bankForm.elements[1].value +_that.$t('profileReq_bankname')  + bankForm.elements[2].value +_that.$t('profileReq_bankcode')+ bankForm.elements[3].value + _that.$t('profileReq_sortcode')+ bankForm.elements[4].value +_that.$t('profileReq_bankAddress')+ bankForm.elements[5].value
                    let form_name = new FormData(bankForm);
                    form_name.append("reason", _that.$parent.reason);
                    form_name.append("reason_text", _that.$parent.reason_text);
                    form_name.append("title", _that.$parent.title);
                    form_name.append("title_text", _that.$parent.title_text);
                    form_name.append("text",comment);
                    _that.$validator.validate().then(valid => {
                        if (valid){
                            let input_json={
                                'globalParams' :{
                                    'form' : form_name
                                },
                                'localParams' :{ "parameter" : _that , 'module' : 'ticket-reply'  }
                            }
                            _that._runTicketRequestOtp(input_json)
                        }
                    })
                }else if(parseInt(_that.ticketFilter.id) == 1 && parseInt(_that.$parent.title) == 90){
                    let addressForm = document.getElementById('addressForm');
                    let comment = _that.$t('profileReq_changeadress')+ addressForm.elements[0].value + _that.$t('profileReq_adresstwo') +  addressForm.elements[1].value + _that.$t('profileReq_postcode') + addressForm.elements[2].value +_that.$t('profileReq_residenceCountry')+ addressForm.elements[3].value + _that.$t('profileReq_nation')+ addressForm.elements[4].value +_that.$t('profileReq_City')+ addressForm.elements[5].value
                    let form_name = new FormData(addressForm);
                    form_name.append("reason", _that.$parent.reason);
                    form_name.append("reason_text", _that.$parent.reason_text);
                    form_name.append("title", _that.$parent.title);
                    form_name.append("title_text", _that.$parent.title_text);
                    form_name.append("text", comment);
                    _that.$validator.validate().then(valid => {
                        if (valid){
                            let input_json={
                                'globalParams' :{
                                    'form' : form_name
                                },
                                'localParams' :{ "parameter" : _that , 'module' : 'ticket-reply'  }
                            }
                            _that._runTicketRequestOtp(input_json)
                        }    
                    })
                }else if(parseInt(_that.ticketFilter.id) == 16){
					if(parseInt(this.$parent.title) == 107 && this.msz == ''){
						let formRequest = document.getElementById('formRequest');
						
						let mnth_year = formRequest.elements[2].value+'/'+formRequest.elements[3].value
						
						let comment = _that.$t('profileReq_pleaseAdd')+ this.$parent.title_text + _that.$t('profileReq_paymentmethod') + this.$parent.title_text+_that.$t('profileReq_number')+ formRequest.elements[0].value+'  **** **** '+formRequest.elements[1].value +_that.$t('profileReq_expiryDate')  + mnth_year;
						
						let form_name = new FormData(formRequest);
						form_name.append("expiry_date",mnth_year);
						form_name.append("method",5 );
						form_name.append("subject", _that.$parent.reason_text);
						form_name.append("text", comment);
						form_name.append("reason", _that.$parent.reason);
						form_name.append("reason_text", _that.$parent.reason_text);
						form_name.append("title", _that.$parent.title);
						form_name.append("title_text", _that.$parent.title_text);
						_that.$validator.validate().then(valid => {
							if (valid){
								let input_json={
									'globalParams' :{
										'form' : form_name
									},
									'localParams' :{ "parameter" : _that , 'module' : 'ticket-reply'  }
								}
								_that._runTicketRequestOtp(input_json)
							}
						})
					}else{
						let formRequest = document.getElementById('formRequest');
						let comment = _that.$t('profileReq_pleaseAdd') + this.$parent.title_text +_that.$t('profileReq_paymentmethod')+ this.$parent.title_text+_that.$t('profileReq_id')+ formRequest.elements[0].value ;
						let form_name = new FormData(formRequest);
						
						/*if(this.$parent.method_id != ''){
							this.title_text =(parseInt(this.$parent.method_id) == 2)? 'Skrill' : 'Netteller'
							this.title =(parseInt(this.$parent.method_id) == 2)? 95 : 96
						}*/
						form_name.append("method",this.$parent.method_id );
						form_name.append("subject", _that.$parent.reason_text);
						form_name.append("text", comment);
						form_name.append("reason", _that.$parent.reason);
						form_name.append("reason_text", _that.$parent.reason_text);
						form_name.append("title", _that.$parent.title);
						form_name.append("title_text", _that.$parent.title_text);
						_that.$validator.validate().then(valid => {
							if (valid){
								let input_json={
									'globalParams' :{
										'form' : form_name
									},
									'localParams' :{ "parameter" : _that , 'module' : 'ticket-reply'  }
								}
								_that._runTicketRequestOtp(input_json)
							}
						})
					}
                }
                else{
                    let formRequest = document.getElementById('formRequest');
                    let form_name = new FormData(formRequest);
                    form_name.append("reason", _that.$parent.reason);
                    form_name.append("reason_text", _that.$parent.reason_text);
                    form_name.append("title", _that.$parent.title);
                    form_name.append("title_text", _that.$parent.title_text);
                    
                    _that.$validator.validate().then(valid => {
                        if (valid){
                            let input_json={
                                'globalParams' :{
                                    'form' : form_name
                                },
                                'localParams' :{ "parameter" : _that , 'module' : 'ticket-reply'  }
                            }
                            _that._runTicketRequestOtp(input_json)
                        }
                    })
                }
            }
        },

        // mounted: function () {
        //     const _that = this
           
        //     $(document).on('keypress', "input[type='text']", function (event) {
        //         event.preventDefault();
        //         var key = event.which || event.keyCode;
        //         if (key > 128) { 
        //             alert("Only English is allowed"); 
        //             return false; 
        //         }else { return true; }
        //     });

            
        // },
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/supports/services/profile_request.vue